import { OperatorOption } from '../constants';

/** LaunchDarkly flag key — boolean; when true, plain-text quick search defaults to CONTAINS. */
export const PUBLIC_SEARCH_DEFAULT_CONTAINS_FLAG =
  'publicSearchDefaultContains';

let cachedDefaultOperator: string = OperatorOption.startsWith.value;

export function setQuickSearchDefaultOperator(operator: string): void {
  cachedDefaultOperator = operator;
}

export function getQuickSearchDefaultOperator(): string {
  return cachedDefaultOperator;
}

export function resolveDefaultQuickSearchOperator(
  publicSearchDefaultContains?: boolean,
): string {
  return publicSearchDefaultContains
    ? OperatorOption.contains.value
    : OperatorOption.startsWith.value;
}
